import { ApiClient } from '../../../../infra';
import { timeSeriesFromBackend } from '../../../../domain';
/**
 * O painel da EMPRESA: media, serie no tempo e distribuicao de faixas.
 *
 * O painel de um PACIENTE tem os seus proprios tres, em
 * `components/patient-analytics/patient-analytics.api.ts` - mesmo vocabulario,
 * endpoints diferentes.
 */
export class DashboardApi {
    constructor() {
        this.client = ApiClient.INSTANCE;
    }
    static { this.INSTANCE = new DashboardApi(); }
    /** Uma empresa pelo id - o seletor a usa para nomear quem chegou pelo endereco. */
    async fetchAnalytics(query, signal) {
        return (await this.client.send('POST', '/dashboard/analytics', query, signal));
    }
    async fetchTimeSeries(metric, query, signal) {
        return timeSeriesFromBackend((await this.client.send('POST', `/dashboard/analytics/time-series/${metric}`, query, signal)));
    }
    async fetchStatusLevels(metric, query, signal) {
        return (await this.client.send('POST', `/dashboard/analytics/status-levels/${metric}`, query, signal));
    }
}
//# sourceMappingURL=dashboard.api.js.map